import { Component } from "./component";

export function AutocompleteFactory(element: HTMLElement, blazorElement: any) {
  return new Autocomplete(blazorElement, element);
}

export class Autocomplete extends Component {
  onOutsideClickFunctions = {};

  constructor(public blazorElement: any, public element: HTMLElement) {
    super(blazorElement, element);
  }

  initialize() {}

  addKeyDownEventListener() {
    this.element.addEventListener("keydown", function (event) {
      let key = event.key;

      if (key === "Enter") {
        event.preventDefault();
      }
    });
  }

  onOutsideClickClear() {
    let bId = "";
    for (
      let clearCount = 0;
      clearCount < this.element.attributes.length;
      clearCount++
    ) {
      let a = this.element.attributes[clearCount];
      if (a.name.startsWith("_bl_")) {
        bId = a.name;
        break;
      }
    }

    let func = this.onOutsideClickFunctions[bId];
    if (func == null || func == "undefined") {
      return;
    }
    window.removeEventListener("click", func);
    this.onOutsideClickFunctions[bId] = null;
  }

  onOutsideClick(methodName, clearOnFire) {

    let dotnetRef = this.blazorElement;
    let searchTextElement = this.element;
    let bId = ""; //get the blazor internal ID to distinguish different components
    for (
      let clearCount = 0;
      clearCount < searchTextElement.attributes.length;
      clearCount++
    ) {
      let a = searchTextElement.attributes[clearCount];
      if (a.name.startsWith("_bl_")) {
        bId = a.name;
        break;
      }
    }

    this.onOutsideClickClear(); //clean up just in case

    let func = function (e) {
      let parent = e.target;
      while (parent != null) {
        if (
          parent.classList != null &&
          parent.classList.contains("blazored-typeahead")
        ) {
          let hasSearch = parent.contains(searchTextElement); //check if this is the same typeahead parent element
          if (hasSearch) {
            return; //we're still in the search so don't fire
          }
        }
        parent = parent.parentNode;
      }

      dotnetRef.invokeMethodAsync(methodName);
      if (clearOnFire) {
        //could also add a check to see if the search element is missing on the DOM to force cleaning up the function?
        this.onOutsideClickClear();
      }
    };
    this.onOutsideClickFunctions[bId] = func; //save a reference to the click function
    window.addEventListener("click", func);
  }
}
